import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const speechDevelopmentTrackingListApi = async (data) => {
  const endPoint = `admin/speech-development-tracking/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
